import { useId, useState, type ReactNode } from 'react';
import { helpFor } from '../i18n/help.hu';

export function HelpText({ helpKey, id }: { helpKey: string; id?: string }) {
  const h = helpFor(helpKey);
  if (!h) return null;
  return (
    <div className="help-text" id={id} role="note">
      <span>
        <b>Mit jelent: </b>
        {h.what}
      </span>
      <span>
        <b>Melyik irány a jó: </b>
        {h.direction}
      </span>
      <span>
        <b>Jó tartomány: </b>
        {h.range}
      </span>
    </div>
  );
}

export function HelpButton({
  label,
  open,
  onToggle,
  controls,
  small,
}: {
  label: string;
  open: boolean;
  onToggle: () => void;
  controls?: string;
  small?: boolean;
}) {
  return (
    <button type="button" className={`help${small ? ' in-th' : ''}`} aria-label={`Súgó: ${label}`} aria-expanded={open} aria-controls={controls} onClick={onToggle}>
      ?
    </button>
  );
}

/** A label with a help icon; the explanation opens BELOW the label (works on touch). */
export function HelpLabel({
  helpKey,
  label,
  children,
  className = 'label',
  as: Tag = 'span',
}: {
  helpKey: string;
  /** Plain-text name used for the aria-label of the icon. */
  label: string;
  children?: ReactNode;
  className?: string;
  as?: 'span' | 'h2';
}) {
  const [open, setOpen] = useState(false);
  const id = useId();
  return (
    <div className="stack" style={{ gap: 6 }}>
      <div className="top" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
        <Tag className={className}>{children ?? label}</Tag>
        <HelpButton label={label} open={open} onToggle={() => setOpen((o) => !o)} controls={id} />
      </div>
      {open ? <HelpText helpKey={helpKey} id={id} /> : null}
    </div>
  );
}
